{
  "users": {
    "title": "Users and permissions",
    "subtitle": "Main owner only · coordinator accounts are managed from each coordinator's page",
    "addOwner": "Add owner",
    "owners": "Owners",
    "disabled": "Disabled",
    "superOwnerSummary": "Main owner · all permissions",
    "ownerSummary": "Added owner · {{n}} permissions",
    "invitePending": "invite pending",
    "empty": "No added owners"
  },
  "permissions": {
    "heading": "Permissions for {{name}}",
    "saved": "Permissions saved — they apply from the user's next request",
    "statusUpdated": "Account status updated",
    "inviteResent": "A new invite was sent",
    "resendInvite": "Resend invite",
    "disable": "Disable account",
    "enable": "Enable account",
    "save": "Save changes",
    "superOwnerNote": "The main owner has every permission, including managing users and settings, and these cannot be changed.",
    "changeEmail": "Change email"
  },
  "invite": {
    "title": "Add owner",
    "description": "They'll get an email invite to set a password. Permissions start empty.",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "phone": "Mobile",
    "required": "Required",
    "submit": "Send invite",
    "sent": "Invite sent (the link is valid for 48 hours)",
    "failed": "Couldn't send the invite"
  }
}
